import { render, staticRenderFns } from "./issuable_item.vue.js?vue&type=template&id=73563e4b!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./issuable_item.vue?vue&type=template&id=73563e4b"
import script from "./issuable_item.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./issuable_item.vue?vue&type=script&lang=js"
export * from "./issuable_item.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./issuable_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports